import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

export const getFaqs = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.FAQ.GET, { params });
  return response;
};
